export default {
  namespaced: true,
  state: {
    user: {
      name: 'John Doe',
      image: '',
      qr_code: 'https://api.qrserver.com/v1/create-qr-code/?size=350x350&data=864927044790706',
      profile: {
        address: 'no 3,ogbe avenue, off pti road, effurun, Warri',
        vendor: 'benelta gas'
      }
    }
  },
  getters: {
    user_info: state => {
      return state.user
    }
  },
  mutations: {},
  actions: {

  }
}
